import { Box } from "@mui/material";

interface VideoProps {
  media: any;
  onError: () => void;
  thumbnailCover?: boolean;
}

export function Video({ media, onError, thumbnailCover = false }: VideoProps) {
  const hasThumbnail = !!media?.thumbnailUrl && thumbnailCover;

  return (
    <Box sx={{ height: "inherit", position: "relative" }}>
      {hasThumbnail && (
        <Box
          component="img"
          src={media.thumbnailUrl}
          alt=""
          sx={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: 0,
          }}
        />
      )}
      <Box
        className="swiper-image img-report"
        component={`${media.mimeType.includes("video") ? "video" : "img"}`}
        controls
        alt="swiper-image"
        src={media.mediaUrl}
        onError={onError}
      />
    </Box>
  );
}
